import { render, staticRenderFns } from "./SchoolSubjectEdit.vue?vue&type=template&id=74a3e5d8&scoped=true"
import script from "./SchoolSubjectEdit.vue?vue&type=script&lang=js"
export * from "./SchoolSubjectEdit.vue?vue&type=script&lang=js"
import style0 from "./SchoolSubjectEdit.vue?vue&type=style&index=0&id=74a3e5d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a3e5d8",
  null
  
)

export default component.exports